// extracted by mini-css-extract-plugin
export default {"questionDetailButton":"ShowQuestionDetail__questionDetailButton___K6J40"};